export * from './datepicker-i18n-custom.service';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/custom-datepicker/service/index.ts